import { makeImmutable } from "../../core";
export class CustomParameterChoice {
    constructor(params) {
        this.id = params.id;
        this.availability = params.availability;
        makeImmutable(this);
    }
}
